import React, { ChangeEvent, FC, useEffect, useState } from 'react'

import cn from 'classnames'
import { EditorState } from 'draft-js'
import { ethers } from 'ethers'

import {
  checkBadWords,
  checkNumberOfLineBreaks,
  convertNumber,
  EthereumChainId,
  getAuthencityObjectERC20,
  getPostLengthFromEditorState,
  getPostTextFromEditorState,
  isAvailableBlockchainProvider,
  isAvailableBlockchainProviderToast,
  isAvailableMMProvider,
  isAvailableWCProvider,
  ViewTypeEditor,
} from 'utils'

import { ApproveAmountModal } from '../ApproveAmountModal'
import { toast } from 'App'
import Button from 'components/Button'
import Modal from 'components/Modal'

import { IUser } from 'models'

import { useStore } from 'store'

import { ReactComponent as CompanyIcon } from 'sources/images/companyIcon.svg'

import { BackersModal } from '../BakersModal'
import ButtonIcon from '../ButtonIcon'
import { CustomEditor } from '../CustomEditor'

import styles from './styles.module.scss'

const { ethereum } = window

type TModalType = 'backPost' | 'offer' | 'backProfile' | 'backStream'

interface IProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  type: TModalType
  user?: IUser
  onBack?: (value: string, hash?: string) => Promise<void>
  onBackStream?: (value: string, message: EditorState) => Promise<void>
  onMakeOffer?: (value: number) => Promise<void>
  isMakeOfferActive?: boolean
  isMyPost?: boolean
  publicationId?: number
  loadInfo?: () => void
  minAmount?: number
  publicationNetworkType?: number
}

enum SwitchType {
  back,
  offer,
}

enum BalanceType {
  system = 'System',
  wallet = 'Wallet',
}

const ModalInfo = {
  backPost: {
    messageText: 'Back this post by:',
    btnText: 'Back This Post',
  },
  offer: {
    messageText: 'Buy this post for:',
    btnText: 'Make offer',
  },
  backProfile: {
    messageText: 'Back this profile by:',
    btnText: 'Back This Profile',
  },
  backStream: {
    messageText: 'Back this stream by:',
    btnText: 'Back This Stream',
  },
}

const getModalInfo = (type: TModalType) => {
  switch (type) {
    case 'backPost':
      return ModalInfo.backPost
    case 'offer':
      return ModalInfo.offer
    case 'backProfile':
      return ModalInfo.backProfile
    case 'backStream':
      return ModalInfo.backStream
    default:
      return ModalInfo.backPost
  }
}

const InitialOfferInfo = {
  AuthencityBalance: 0,
  TotalAuthBacked: 0,
  AverageAuthByUser: 0,
  HighestBidPrice: 0,
}

//Resize
export const BackedModal: FC<IProps> = ({
  type,
  loadInfo,
  setIsOpen,
  isOpen,
  onBack,
  onBackStream,
  minAmount,
  onMakeOffer,
  isMakeOfferActive,
  isMyPost,
  publicationId,
  publicationNetworkType,
  user,
}) => {
  const {
    loading,
    donate,
    profile,
    theme,
    authToken,
    walletConnect,
    marketplace,
    mediaQuery,
  } = useStore()
  const [amount, setAmount] = useState('')
  const [backedBy, setBackedBy] = useState(0)
  const [offerInfo, setOfferInfo] = useState(InitialOfferInfo)
  const [switchType, setSwitchType] = useState<SwitchType>(SwitchType.back)
  const [balanceSwitchType, setBalanceSwitchType] = useState<BalanceType>(
    BalanceType.system
  )
  const [modalInfo, setModalInfo] = useState(getModalInfo(type))
  const [isOpenBackersModal, setIsOpenBackersModal] = useState(false)
  const [isEthereumNetwork, setIsEthereumNetwork] = useState<boolean>(false)
  const [walletBalance, setWalletBalance] = useState(0)
  const [approvedWalletBalance, setApprovedWalletBalance] = useState(0)
  const [minimumOfferPrice, setMinimumOfferPrice] = useState(0)
  const [isOpenApproveAmountModal, setIsOpenApproveAmountModal] =
    useState(false)
  const [backStreamMessage, setBackStreamMessage] = useState(
    EditorState.createEmpty()
  )

  const backPost = type === 'backPost'
  const backProfile = type === 'backProfile'
  const backStream = type === 'backStream'

  const backStreamMessageQuantity = backStream
    ? getPostLengthFromEditorState(backStreamMessage)
    : 0

  useEffect(() => {
    backProfile && isOpen && getBackedByUser()

    if (isOpen) {
      getInfo()
      checkNetwork()

      if (isAvailableMMProvider()) {
        ethereum.on('chainChanged', () => checkNetwork())
      }
    }
  }, [isOpen])

  useEffect(() => {
    if (isOpen) {
      checkNetworkWalletConnect()
    }
  }, [walletConnect.chainId, isOpen])

  useEffect(() => {
    if (balanceSwitchType === BalanceType.wallet && isOpen) {
      // if (isEthereumNetwork) {
      getWalletBalance()
      // }
    }
  }, [isEthereumNetwork, balanceSwitchType, isOpen])

  //For make offer ---------------------------------------------------↓↓↓
  useEffect(() => {
    if (switchType === SwitchType.offer && isOpen) {
      //For now is not enable
      // getApprovedWalletBalance()
      getMinimumNextOffer()
      //For now is not enable
      // if (isEthereumNetwork) {
      //   getWalletBalance()
      // } else {
      //   toast({
      //     type: 'warning',
      //     message: 'You can make offer only on the Ethereum network. Change your network to Ethereum'
      //   })
      //   setWalletBalance(0)
      // }
    }
  }, [isEthereumNetwork, switchType, isOpen])

  useEffect(() => {
    if (isOpen) {
      getMinimumNextOffer()
    }
  }, [offerInfo, isOpen])

  const checkNetwork = async () => {
    if (isAvailableMMProvider()) {
      const provider = new ethers.BrowserProvider(ethereum)
      const { chainId } = await provider.getNetwork()
      setIsEthereumNetwork(Number(chainId) === EthereumChainId)
    }
  }

  const checkNetworkWalletConnect = async () => {
    if (isAvailableWCProvider()) {
      const chainId = walletConnect.chainId
      setIsEthereumNetwork(chainId === EthereumChainId)
    }
  }

  const getWalletBalance = async () => {
    try {
      if (isAvailableMMProvider()) {
        const response = await authToken.getAuthBalance()
        setWalletBalance(response)
      }
      if (isAvailableWCProvider()) {
        const response = await authToken.getAuthBalanceWalletConnect()
        setWalletBalance(response)
      }
    } catch (e) {
      console.log('e', e)
      toast({
        type: 'warning',
        message: 'Error when retrieving your balance',
      })
    }
  }

  const getApprovedWalletBalance = async () => {
    try {
      if (user) {
        const approvedAmount = await marketplace.getApprovedAmount(user.Wallet)
        setApprovedWalletBalance(approvedAmount)
      }
    } catch (e) {
      console.log('e', e)
      toast({
        type: 'warning',
        message: 'Failed to get your approved wallet balance',
      })
    }
  }

  const getMinimumNextOffer = async () => {
    const nextOffer30up = +((offerInfo.TotalAuthBacked / 100) * 130).toFixed(2)
    setMinimumOfferPrice(Math.max(nextOffer30up, offerInfo.HighestBidPrice))
  }

  const onApproveAmountSuccess = async () => {
    await refreshMakeOfferData()
    loading.setLoading(false)
  }
  //For make offer --------------------------------------------------------↑↑↑

  const getInfo = async () => {
    if (!isAvailableBlockchainProvider()) return

    try {
      if (backProfile || backStream) {
        const response = await authToken.getBalanceAvailableToClaim()
        setOfferInfo(response)
      } else {
        const response = await authToken.getBalanceAvailableToClaim(
          publicationId
        )
        setOfferInfo(response)
      }
    } catch (e) {
      toast({
        type: 'warning',
        message: 'Error when retrieving your balance',
      })
    }
  }

  const getBackedByUser = async () => {
    try {
      const res = await donate.getBackedByUserInfo(profile.getActiveProfileId())
      setBackedBy(res)
    } catch (e) {
      console.log('getBackedByUser', e)
    }
  }

  const onChangeCount = (e: ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target

    setAmount(value)

    if (+value > selectedBalance) {
      toast({
        type: 'warning',
        message: 'You have not enough AUTH to back this stream',
      })
    }
    // if (checkStringNumber(value)) {
    //   setAmount(value)
    // }
  }

  const onSendBacked = async () => {
    try {
      if (amount) {
        if (isMyPost) {
          return toast({
            type: 'warning',
            message: `You can't back your own posts`,
          })
        }

        if (
          balanceSwitchType === BalanceType.wallet
          // && !isEthereumNetwork
        ) {
          return toast({
            type: 'warning',
            message:
              'From the wallet, you can only back on the Ethereum network. Change network to Ethereum',
          })
        }

        if (Number(amount) < 0.1) {
          return toast({
            type: 'warning',
            message: 'The amount must be greater than or equal to 0.1',
          })
        }

        if (minAmount) {
          if (Number(amount) < minAmount) {
            return toast({
              type: 'warning',
              message: `The number cannot be less than ${minAmount}`,
            })
          }
        }

        if (switchType === SwitchType.offer) {
          if (Number(amount) <= minimumOfferPrice) {
            return toast({
              type: 'warning',
              message: 'The number must be greater than the min next offer',
            })
          }

          //For now is not enable
          // if (balanceSwitchType === BalanceType.wallet && Number(amount) > walletBalance) {
          //   return toast({
          //     type: 'warning',
          //     message: 'You do not have this amount of AUTH in your wallet'
          //   })
          // }

          if (
            balanceSwitchType === BalanceType.system &&
            Number(amount) > offerInfo.AuthencityBalance
          ) {
            return toast({
              type: 'warning',
              message:
                'You do not have this amount of AUTH in your system balance!!!',
            })
          }
        }

        if (
          switchType !== SwitchType.offer &&
          (balanceSwitchType as any) === BalanceType.wallet &&
          Number(amount) > walletBalance
        ) {
          return toast({
            type: 'warning',
            message: 'You do not have this amount of AUTH in your wallet',
          })
        }

        if (backStream) {
          if (backStreamMessageQuantity > 100) {
            return toast({
              type: 'warning',
              message:
                'The number of characters in the message exceed the limit of 100',
            })
          }

          // if (backStreamMessageQuantity <= (getPostTextFromEditorState(backStreamMessage).match(/ /g) || []).length) {
          //   return toast({
          //     type: 'warning',
          //     message: 'Invalid message!'
          //   })
          // }

          if (
            checkNumberOfLineBreaks(
              getPostTextFromEditorState(backStreamMessage)
            )
          ) {
            return toast({
              type: 'warning',
              message:
                'You are not allowed to use more than 2 line breaks together in message',
            })
          }

          if (checkBadWords(getPostTextFromEditorState(backStreamMessage))) {
            return toast({
              type: 'warning',
              message: 'You are not allowed to use prohibited words in message',
            })
          }
        }

        loading.setLoading(true)
        if (switchType === SwitchType.back) {
          if (profile.selectedUser.Activated) {
            const onSuccessDonate = async () => {
              closeModal()
              loadInfo && (await loadInfo())
              loading.setLoading(false)
              toast({
                type: 'success',
                message: `You have successfully backed ${
                  backProfile ? 'profile' : backStream ? 'stream' : 'post'
                }`,
              })
            }

            if (
              (balanceSwitchType as any) === BalanceType.wallet
              // && isEthereumNetwork
            ) {
              if (!isAvailableBlockchainProviderToast()) return

              const ObjectERC20 = await getAuthencityObjectERC20()

              if (ObjectERC20) {
                const convertedAmount = convertNumber(Number(amount))

                ObjectERC20.burn(convertedAmount)
                  .then(async (res: any) => {
                    onBack && (await onBack(amount, res.hash))
                    onBackStream &&
                      (await onBackStream(amount, backStreamMessage))
                    await onSuccessDonate()
                  })
                  .catch((e: any) => {
                    console.log('ObjectERC20.burn', e)
                    loading.setLoading(false)
                    toast({
                      type: 'warning',
                      message: e.message || 'Some error!',
                    })
                  })
              }
            } else {
              onBack && (await onBack(amount))
              onBackStream && (await onBackStream(amount, backStreamMessage))
              await onSuccessDonate()
            }
          } else {
            loading.setLoading(false)
            toast({
              type: 'warning',
              // message: 'This feature is not available because you have not yet created a post on the Ethereum network.'
              message: 'You need to be Activated to back other users',
            })
          }
        } else {
          if (onMakeOffer) {
            const offerAmount = Number(amount.replace(/,/g, '.'))
            const makeOffer = async (amount: number) => {
              await onMakeOffer(amount)
              closeModal()
              loadInfo && (await loadInfo())
              toast({
                type: 'success',
                message: 'The offer was successfully made',
              })
              loading.setLoading(false)
            }

            //System
            if (balanceSwitchType === BalanceType.system) {
              await makeOffer(offerAmount)
            }
            //  Wallet
            // else if (balanceSwitchType === BalanceType.wallet) {
            //   const onSuccess = async (amount: number) => {
            //     await marketplace.updateApprovedAmount(amount)
            //     await makeOffer(amount)
            //   }
            //
            //   const onError = async (message?: string) => {
            //     toast({
            //       type: 'error',
            //       message: message ? message : 'An error occurred while creating the offer'
            //     })
            //     loading.setLoading(false)
            //   }
            //
            //   if (approvedWalletBalance >= offerAmount) {
            //     await makeOffer(offerAmount)
            //   } else {
            //     const amountToBeApproved = offerAmount - approvedWalletBalance
            //     console.log('amountToBeApproved', amountToBeApproved)
            //     await approveAmount(amountToBeApproved, onSuccess, onError)
            //   }
            // }
          }
        }
      } else {
        return toast({
          type: 'warning',
          message: 'Add the amount',
        })
      }
    } catch (e: any) {
      loading.setLoading(false)
      toast({
        type: 'error',
        message: e.message,
      })
    }
  }

  //Need because component didn't unmount on close
  const closeModal = () => {
    setIsOpen(false)
    setAmount('')
    setSwitchType(SwitchType.back)
    setBalanceSwitchType(BalanceType.system)
    setModalInfo(getModalInfo(type))
    setIsEthereumNetwork(false)
    setWalletBalance(0)
    // setApprovedWalletBalance(0)
    setMinimumOfferPrice(0)
  }
  const handlerSwitchClick = (value: SwitchType) => {
    setSwitchType(value)
    if (value === SwitchType.back) {
      setModalInfo(ModalInfo.backPost)
    } else {
      setBalanceSwitchType(BalanceType.system)
      setModalInfo(ModalInfo.offer)
    }
  }

  const handlerWalletSwitchClick = (value: BalanceType) => {
    setBalanceSwitchType(value)
  }

  const openPostBackersModal = () => {
    if (offerInfo.AverageAuthByUser > 0) {
      loading.setLoading(true)
      setIsOpenBackersModal(true)
    }
  }

  const openApproveAmountModal = () => {
    setIsOpenApproveAmountModal(true)
  }

  const refreshMakeOfferData = async () => {
    await getInfo()
    //For now is not enable
    // await getApprovedWalletBalance()
    // if (isEthereumNetwork) {
    //   await getWalletBalance()
    // } else {
    //   toast({
    //     type: 'warning',
    //     message: 'You can make offer only on the Ethereum network. Change your network to Ethereum'
    //   })
    //   setWalletBalance(0)
    // }
  }

  const selectedBalance =
    balanceSwitchType === BalanceType.system
      ? offerInfo.AuthencityBalance
      : walletBalance

  const infoItem = (title: string, count: number, handler?: () => void) => {
    return (
      <div
        className={cn({
          [styles.infoItem]: true,
          [styles.infoItemHandler]: handler,
        })}
        onClick={handler}
      >
        {handler ? (
          <ButtonIcon
            style={{
              position: 'absolute',
              minWidth: mediaQuery.minWidth_2200 ? '16px' : '13px',
              width: mediaQuery.minWidth_2200 ? '16px' : '13px',
              height: mediaQuery.minWidth_2200 ? '16px' : '13px',
              top: '-2px',
              right: '-2px',
            }}
            styleIcon={{
              width: mediaQuery.minWidth_2200 ? '8px' : '7px',
              height: mediaQuery.minWidth_2200 ? '8px' : '7px',
            }}
            icon={'info'}
            tooltip="Click to see all backers"
            tooltipPosition="top"
            bordered
          />
        ) : null}

        <div className={styles.infoItemTop}>
          <CompanyIcon className={styles.infoItemIcon} />
          <div className={styles.infoItemCount}>{count}</div>
        </div>
        <div className={styles.infoItemTitle}>{title}</div>
      </div>
    )
  }

  const handleChangeBackStreamMessage = (editorState: EditorState) => {
    setBackStreamMessage(editorState)
  }

  return (
    <Modal
      blockOutsideClose
      onClose={closeModal}
      open={isOpen}
      size={'small'}
      closeButton={true}
      children={
        <div className={styles.modalContent}>
          {!backProfile && !backStream && isMakeOfferActive ? (
            <div className={styles.switch}>
              <div
                className={cn({
                  [styles.switchBtn]: true,
                  [styles.btnPositionRight]: switchType === SwitchType.offer,
                })}
              />
              <div
                className={cn({
                  [styles.back]: true,
                  [styles.inactive]: switchType !== SwitchType.back,
                })}
                onClick={() => handlerSwitchClick(SwitchType.back)}
              >
                Back post
              </div>
              <div
                className={cn({
                  [styles.offer]: true,
                  [styles.inactive]: switchType !== SwitchType.offer,
                })}
                onClick={() => handlerSwitchClick(SwitchType.offer)}
              >
                Make offer
              </div>
            </div>
          ) : null}

          {/*Wallet Switch*/}
          {switchType !== SwitchType.offer ? (
            <div
              className={cn({
                [styles.walletSwitchBlock]: true,
                [styles.walletSwitchBlockOnlyBack]:
                  backProfile || backStream || !isMakeOfferActive,
              })}
            >
              <div className={styles.walletSwitchTitle}>AUTH source:</div>
              <div className={cn(styles.switch, styles.walletSwitch)}>
                <div
                  className={cn({
                    [styles.switchBtn]: true,
                    [styles.btnPositionRight]:
                      balanceSwitchType === BalanceType.wallet,
                  })}
                />
                <div
                  className={cn({
                    [styles.back]: true,
                    [styles.inactive]: balanceSwitchType !== BalanceType.system,
                  })}
                  onClick={() => handlerWalletSwitchClick(BalanceType.system)}
                >
                  System
                </div>
                <div
                  className={cn({
                    [styles.offer]: true,
                    [styles.inactive]: balanceSwitchType !== BalanceType.wallet,
                  })}
                  onClick={() => handlerWalletSwitchClick(BalanceType.wallet)}
                >
                  Wallet
                </div>
              </div>
            </div>
          ) : null}

          <div
            className={cn({
              [styles.modalBody]: true,
              [styles.modalBodyTwoSwitch]:
                !backProfile &&
                !backStream &&
                isMakeOfferActive &&
                switchType !== SwitchType.offer,
              // [styles.modalBodyOneSwitch]:
              //For now not enable
              // [styles.modalBodyOffer]: switchType === SwitchType.offer
            })}
          >
            <div>
              <div className={styles.topBlock}>
                <div className={styles.balanceLabelBlock}>
                  <div className={styles.modalLabel}>
                    {modalInfo.messageText}
                  </div>
                  <div className={styles.balance}>
                    {/*{switchType === SwitchType.offer*/}
                    {/*  ? balanceSwitchType === BalanceType.system ? `Your system balance ${offerInfo.AuthencityBalance} AUTH` : `Your wallet balance ${walletBalance} AUTH`*/}
                    {/*  : `Your balance ${offerInfo.AuthencityBalance} AUTH`}*/}
                    {balanceSwitchType === BalanceType.system
                      ? `Your system balance ${offerInfo.AuthencityBalance} AUTH`
                      : `Your wallet balance ${walletBalance} AUTH`}
                  </div>
                </div>
                <div className={styles.modalInputBody}>
                  <input
                    step="0.1"
                    type="number"
                    value={amount}
                    onChange={onChangeCount}
                    className={styles.modalInput}
                  />
                  {/*<input*/}
                  {/*  type="string"*/}
                  {/*  value={amount}*/}
                  {/*  onChange={onChangeCount}*/}
                  {/*  className={styles.modalInput}*/}
                  {/*/>*/}
                  <CompanyIcon />
                </div>
              </div>

              {/*{switchType === SwitchType.offer && balanceSwitchType === BalanceType.wallet*/}
              {/*  ? <div className={cn(styles.topBlock, styles.approvedBalance)}>*/}
              {/*    <div className={styles.balanceLabelBlock}>*/}
              {/*      <div className={styles.modalLabel}>Approved balance:</div>*/}
              {/*    </div>*/}
              {/*    <div className={styles.modalInputBody}>*/}
              {/*      <input*/}
              {/*        disabled*/}
              {/*        type="number"*/}
              {/*        value={approvedWalletBalance}*/}
              {/*        onChange={onChangeCount}*/}
              {/*        className={cn(styles.modalInput, styles.modalInputDisabled)}*/}
              {/*      />*/}
              {/*      <CompanyIcon />*/}
              {/*      <ButtonIcon*/}
              {/*        style={{*/}
              {/*          position: 'absolute',*/}
              {/*          top: '5px',*/}
              {/*          right: '-24px',*/}
              {/*          minWidth: '19px',*/}
              {/*          width: '19px',*/}
              {/*          height: '19px'*/}
              {/*        }}*/}
              {/*        styleIcon={{ width: '19px', height: '19px' }}*/}
              {/*        disabledHoverStyle*/}
              {/*        iconSource={plusIcon}*/}
              {/*        tooltip="Increase approved amount"*/}
              {/*        tooltipPosition="top"*/}
              {/*        onClick={openApproveAmountModal}*/}
              {/*      />*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*  : null*/}
              {/*}*/}
            </div>

            {backPost ? (
              <div className={styles.middleBlock}>
                {switchType === SwitchType.back ? (
                  <>
                    {infoItem('Total invested', offerInfo.TotalAuthBacked)}
                    {infoItem(
                      'Avg per user',
                      offerInfo.AverageAuthByUser,
                      openPostBackersModal
                    )}
                  </>
                ) : (
                  <>
                    {infoItem('Highest offer', offerInfo.HighestBidPrice)}
                    {infoItem('Min offer price', minimumOfferPrice)}
                  </>
                )}
              </div>
            ) : null}
            {backProfile ? (
              <div className={styles.bottomBlock}>
                {backedBy > 0
                  ? `You have already backed this profile with: ${backedBy} AUTH`
                  : `You are not yet backing this profile`}
              </div>
            ) : null}

            {backStream ? (
              <div className={styles.backStreamMessageBlock}>
                <div className={styles.backStreamMessageTitle}>
                  <div>Message</div>
                  <div
                    className={cn({
                      [styles.charactersQuantity]: true,
                      [styles.charactersQuantityError]:
                        backStreamMessageQuantity > 100,
                    })}
                  >
                    {backStreamMessageQuantity}/100
                  </div>
                </div>
                <CustomEditor
                  viewType={ViewTypeEditor.editorWithoutAvatar}
                  editorAutoHeightWithMaxHeight
                  withoutToolbar
                  placeholder={'Message with a donation'}
                  editorState={backStreamMessage}
                  setEditorState={handleChangeBackStreamMessage}
                  styleContainer={{
                    margin: 0,
                    // @ts-ignore
                    '--CustomEditorMinHeight': '39px',
                  }}
                />
              </div>
            ) : null}
          </div>
          <div className={styles.modalFooter}>
            <Button
              onClick={onSendBacked}
              style={{
                width: '100%',
                height: mediaQuery.minWidth_2200 ? '50px' : '40px',
                borderRadius: 7,
                background:
                  'linear-gradient(131.69deg, #1f45c3 6.46%, #0e219b 100%)',
                opacity: +amount <= 0 || +amount > selectedBalance ? 0.43 : 1,
              }}
              styleText={{ color: '#ffffff' }}
              btnStyle="classic"
              text={modalInfo.btnText}
              disabled={+amount <= 0 || +amount > selectedBalance}
            />
          </div>
          {isOpenBackersModal ? (
            <BackersModal
              publicationId={publicationId}
              isOpen={isOpenBackersModal}
              setIsOpen={setIsOpenBackersModal}
              type={2}
            />
          ) : null}

          {isOpenApproveAmountModal ? (
            <ApproveAmountModal
              isOpen={isOpenApproveAmountModal}
              setIsOpen={setIsOpenApproveAmountModal}
              onApproveAmountSuccess={onApproveAmountSuccess}
              approvedWalletBalance={approvedWalletBalance}
              walletBalance={walletBalance}
            />
          ) : null}
        </div>
      }
    />
  )
}

BackedModal.displayName = 'BackedModal'
